import { EmbeddingModel } from '../Types';
import requestClient from '../components/Utility/RequestClient';
import Store from '../Store/Store';

const resolveDemo = () => Store.getState().environment.demoInstance;

export const embeddingModelService = {
    saveModel: async (type: string, data: any): Promise<any> => {
        return requestClient.post<EmbeddingModel>(`/embeddingmodel/${type}`, data);
    },

    getModelsByPage: (
        page: number,
        itemsPerPage: number,
        additionalParams?: Record<string, any>,
        query?: string | null,
    ): Promise<{ data: { data: EmbeddingModel[]; total: number } }> => {
        return requestClient
            .get(`${resolveDemo() ? 'demo' : ''}/embeddingmodel/get`, {
                params: {
                    page,
                    itemsPerPage,
                    query,
                },
            })
            .then((response: any) => response);
    },

    getModels: async (): Promise<{ data: EmbeddingModel[] }> => {
        const demo = resolveDemo();
        return requestClient.get<EmbeddingModel[]>(`${demo ? 'demo' : ''}/embeddingmodel/get`);
    },

    getModel: async (modelIdentifier: string): Promise<{ data: EmbeddingModel }> => {
        return requestClient.get<EmbeddingModel>(`/embeddingmodel/get/${modelIdentifier}`);
    },

    deleteModel: async (identifier: string): Promise<any> => {
        return requestClient.delete(`/embeddingmodel/delete/${identifier}`);
    },

    getAllModelsPaginated: async (itemsPerPage: number = 1): Promise<EmbeddingModel[]> => {
        const firstResponse = await embeddingModelService.getModelsByPage(1, itemsPerPage);
        const { data: firstData, total } = firstResponse.data;

        const totalPages = Math.ceil(total / itemsPerPage);

        if (totalPages <= 1) {
            return firstData;
        }

        const pagePromises = [];
        for (let page = 2; page <= totalPages; page++) {
            pagePromises.push(embeddingModelService.getModelsByPage(page, itemsPerPage));
        }

        const responses = await Promise.all(pagePromises);
        const allData = responses.flatMap((res) => res.data.data);
        if (!Array.isArray(firstData) || !Array.isArray(allData)) {
            return [];
        }
        return firstData.concat(allData);
    },
};
